/**
 * Query params that must NOT travel from one funnel page to the next (PPI-1770).
 *
 * The funnel preserves the query string by denylist: every step navigation copies
 * whatever is in the current URL and deletes only the names below, so a new
 * marketing param starts working with no code change. `readFromQueryParameters`
 * already lists ~40 marketing params it reads into the session at entry; none of
 * them need to be enumerated here, which is the point of the denylist.
 *
 * What is denied is the census/quote half of that same list — PII and quote state
 * that has no business traveling to `/thank-you`, and which the session already
 * holds. `agent_id` is deliberately absent: it is attribution, and the enroll
 * funnel's priority-101 routing rule matches on it.
 *
 * A param the target sets explicitly is always applied, even when it appears
 * here — `application/index.ts` rebuilds `planid`/`period`/`policies` from state
 * on purpose.
 */
const NON_TRAVELING_PARAM_NAMES = [
  // Session identity — re-read from storage on each page, never inherited.
  'session_id',
  // Applicant PII.
  'fname',
  'lname',
  'email',
  'phone_number',
  'gender',
  'dob',
  'spouse',
  'dob_s',
  'gender_s',
  'fname_s',
  'lname_s',
  // Quote state — the session and the page's own query own these.
  'zip',
  'county',
  'coverage',
  'period',
  'planid',
  'policies',
  'sdate',
  'endDate',
  'plans',
  'add_on',
  'externalPlanId',
  'externalPlanIds',
  'flexLevels',
  'mc_plans',
  'compare_plans',
  'quoteKey',
  'state'
] as const

/** Dependent PII is indexed: `dob_1`, `gender_2`, `fname_3`, … */
const MAX_DEPENDENTS = 9

const DEPENDENT_PARAM_NAMES = Array.from(
  { length: MAX_DEPENDENTS },
  (_, index) => index + 1
).reduce<Array<string>>(
  (names, n) => names.concat([`dob_${n}`, `gender_${n}`, `fname_${n}`, `lname_${n}`]),
  []
)

export default [...NON_TRAVELING_PARAM_NAMES, ...DEPENDENT_PARAM_NAMES]
